module.exports = __webpack_public_path__ + "media/images/Package System Combination/header26-7b9eae767a0316e5adf08114f28a9e20.png";